<template>
  <div class="form-row">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-12 p-4': isAdmin, 'col-md-12 mb-0': !isAdmin }">
      <div class="form-group">
        <h3 class="text-center mb-0">
          Training Information
        </h3>
      </div>
      <template v-if="training_info.length > 0">
        <div class="d-flex flex-wrap justify-content-between">
          <div v-for="(item, index) in training_info" :key="index" class="col-md-6 my-2">

             <div class="card-item">
                <div class="form-group row align-items-center">
                  <div class="col-6">
                    <label class="col-sm-12 mb-sm-1">{{ item.title }}</label>
                    <label class="col-sm-12 mb-sm-1">{{ item.awarding_body }}</label>
                    <label class="col-sm-12 mb-sm-1">Award Date {{ dateFormatter(item.award_date) }}</label>
                    <label class="col-sm-12 mb-sm-1">Expiry Date {{ dateFormatter(item.expiry_date) }}</label>
                  </div>

                  <div class="col-6" v-if="isAdmin">
                    <div v-if="item.screening_endorsement && item.screening_endorsement.requested_at">
                      <p class="mb-1 small"><strong>Endorsements</strong></p>
                      <p class="mb-0 small text-muted">Req: {{ item.screening_endorsement.requested_at }}</p>
                      <p v-if="item.screening_endorsement.endorsed_at" class="mb-0 small text-muted">
                        End: {{ item.screening_endorsement.endorsed_at }}
                      </p>
                      <p class="mb-0 small"><strong>Status:</strong> {{ item.screening_endorsement.status }}</p>
                    </div>

                    <div v-if="getLatestStatus(item)"
                         :class="getHighlightClass(getLatestStatus(item))"
                         :style="getHighlightStyle(getLatestStatus(item))"
                    >
                      {{ getStatusValue(getLatestStatus(item)) }}
                    </div>

                    <div v-if="!getLatestStatus(item)"
                         class="highlight-orange"
                    >Verification Pending
                    </div>
                  </div>
                  


                  <div class="col-6" v-if="!isAdmin && isRevertToApplicant(getLatestStatus(item))">
                    <div class="highlight-orange mt-2">
                       To do: {{ getStatusComment(getLatestStatus(item)) }}
                    </div>
                  </div>

                  <div class="col-sm-12 mt-sm-3 d-flex flex-wrap" v-if="!isReadOnly">
                    <el-button class="btn btn-danger el-button--default float-right ml-sm-2"
                               @click="UpdateBtnHandler(index)">
                      Edit
                    </el-button>
                    <el-button class="btn btn-danger el-button--default float-right ml-sm-4"
                               @click="RemoveBtnHandler(index)">
                      Remove
                    </el-button>
                    <div class="float-right mr-sm-2" v-if="isAdmin" >
                      <drawer-component title="Comments" size="70%" btnText="Take Action"
                                        v-if="hasScreeningSchedule"
                                        :open="true">
                        <training-comments
                            :comment="item.screening_status"
                            :applicantId="candidateId"
                            :statusable_type="item.statusable_type"
                            :statusable_id="item.id"
                            :training="item"
                            :emailAddress="emailAddress"
                            @status-updated="handleStatusUpdate(item, $event)"
                            @status-deleted="onTrainingStatusDeleted(item, $event)"
                        />
                      </drawer-component>
                      <div v-else class="screening-note">
                        Add this profile to Screening to proceed.
                      </div>
                    </div>
                  </div>
                </div>
              </div>




          </div>
        </div>
      </template>
      
      <!-- Read-only mode: Show question when no training data -->
      <div class="form-group row align-items-center" v-if="isReadOnly && training_info.length === 0">
        <label class="col-sm-12 mb-sm-2">Do you have any professional training?</label>
        <app-input class="col-sm-12"
                   type="radio"
                   :list="yesOrNoList"
                   :disabled="true"
                   v-model="is_training"/>
      </div>
      
      <!-- Editable mode: Show question with full form -->
      <div class="form-row align-items-center ml-sm-2" v-if="!isReadOnly">
        <div class="col-sm-12 d-flex align-items-center mt-3">
          <label class="mb-0 mr-3">Do you have any professional training?</label>
          <app-input
              type="radio"
              :list="yesOrNoList"
              v-model="is_training"/>
        </div>

        <template v-if="is_training === 'yes'">
          <div class="col-sm-12 mt-3">
            <div class="form-group">
              <label class="mb-1">Training Title</label>
              <app-input
                  type="text"
                  v-model="trainingObj.title"
                  placeholder="Training Title"/>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label class="mb-1">Awarding Body</label>
              <app-input
                  type="text"
                  v-model="trainingObj.awarding_body"
                  placeholder="Awarding Body"/>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label class="mb-1">Award Date</label>
              <app-input
                  type="date"
                  :max-date="today"
                  v-model="trainingObj.award_date"
                  placeholder="Awarding Date"/>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="form-group">
              <label class="mb-1">Expiry Date</label>
              <app-input
                  type="date"
                  :min-date="today"
                  v-model="trainingObj.expiry_date"
                  placeholder="Expiry Date"/>
            </div>
          </div>

          <div class="col-sm-12 no-print">
            <div class="form-group">
              <label class="mb-1">Upload Certificate <b class="text-danger">*</b></label>
              <app-input
                  type="file"
                  v-model="trainingObj.certificate"
                  v-on:change="trainingObjCertificateChange($event)" />
              
              <div v-if="trainingObj.pending_certificate || trainingObj.certificate_path || trainingObj.certificate_preview" class="col-sm-12 document-preview-container mt-3">
                <div class="document-preview-card" @click="viewCertificate(trainingObj.certificate_path || trainingObj.certificate_preview)" style="cursor: pointer;">
                  
                  <div class="file-thumbnail-box" v-if="trainingObj.pending_certificate">
                    <button type="button" class="clear-file-btn" @click.stop="clearCertificateSelection">
                      <app-icon name="x" style="width: 14px; height: 14px;" />
                    </button>
                    
                    <img v-if="isImage(trainingObj.certificate_name || trainingObj.certificate_preview)" 
                         :src="getFileUrl(trainingObj.certificate_preview)" 
                         alt="Certificate Preview">
                    
                    <div v-else class="file-icon-large">
                      <app-icon :name="getFileIcon(trainingObj.certificate_name)" style="width: 48px; height: 48px;" />
                    </div>
                  </div>
                  
                  <div class="file-thumbnail-box" v-else-if="trainingObj.certificate_path">
                    <button v-if="!isReadOnly" 
                            type="button" 
                            class="clear-file-btn" 
                            @click.stop="clearCertificateSelection">
                      <app-icon name="x" style="width: 14px; height: 14px;" />
                    </button>

                    <img v-if="isImage(trainingObj.certificate_name || trainingObj.certificate_path)" 
                         :src="getFileUrl(trainingObj.certificate_path)" 
                         alt="Certificate Preview">
                    
                    <div v-else class="file-icon-large">
                      <app-icon :name="getFileIcon(trainingObj.certificate_name || trainingObj.certificate_path)" style="width: 48px; height: 48px;" />
                    </div>
                  </div>

                  <div class="file-name-text" :title="trainingObj.certificate_name">
                    {{ trainingObj.certificate_name || 'Certificate' }}
                  </div>

                  <div class="upload-status-badge">
                     <template v-if="!trainingObj.pending_certificate && trainingObj.certificate_path">
                        <app-icon name="check-circle" style="width: 14px; height: 14px;" /> Uploaded <app-icon name="check" style="width: 14px; height: 14px;" />
                     </template>
                     <template v-else-if="trainingObj.pending_certificate">
                        <app-icon name="check-circle" style="width: 14px; height: 14px;" /> Selected <app-icon name="check" style="width: 14px; height: 14px;" />
                     </template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 mt-3 text-right">
            <el-button class="btn el-button--success"
                       @click="AddBtnHandler()">
              Save And Add More
            </el-button>
          </div>
        </template>
      </div>
      <template v-if="is_modal">
        <app-modal
            :modal-id="modalId"
            modal-alignment="top"
            modal-size="fullscreen"
            @close-modal="closeModal"
        >
          <template slot="header">
            <h5 class="modal-title">{{ $t("Training Detail") }}</h5>
            <button
                type="button"
                class="close outline-none"
                data-dismiss="modal"
                aria-label="Close"
            >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
            </button>
          </template>
          <template slot="body">
            <div class="card card-with-search border-0 card-with-shadow">
              <div class="form-group row align-items-center mb-sm-2 p-2">
                <label class="col-sm-2 mb-sm-0">Training Title</label>
                <app-input class="col-sm-10 mb-sm-2"
                           type="text"
                           v-model="trainingObj.title"
                           placeholder="Type training title"/>
                <label class="col-sm-2 mb-sm-0">Awarding Body</label>
                <app-input class="col-sm-10 mb-sm-2"
                           type="text"
                           v-model="trainingObj.awarding_body"
                           placeholder="Input info about awarding body"/>
                <label class="col-sm-2 mb-sm-0">Award Date</label>
                <app-input class="col-sm-10 mb-sm-3"
                           type="date"
                           v-model="trainingObj.award_date"
                           :max-date="today"
                           placeholder="Awarding Date"/>
                <label class="col-sm-2 mb-sm-0">Expiry Date</label>
                <app-input class="col-sm-10 mb-sm-2"
                           type="date"
                           v-model="trainingObj.expiry_date"
                           placeholder="Expiry Date"/>
                
                <label class="col-sm-2 mb-sm-0">Upload Certificate</label>
                <div class="col-sm-10">
                  <app-input
                      type="file"
                      v-model="trainingObj.certificate"
                      v-on:change="trainingObjCertificateChange($event)" />
                  
                  <div v-if="trainingObj.pending_certificate || trainingObj.certificate_path || trainingObj.certificate_preview" class="col-sm-12 document-preview-container mt-3">
                    <div class="document-preview-card" @click="viewCertificate(trainingObj.certificate_path || trainingObj.certificate_preview)" style="cursor: pointer;">
                      
                      <div class="file-thumbnail-box" v-if="trainingObj.pending_certificate">
                        <button type="button" class="clear-file-btn" @click.stop="clearCertificateSelection">
                          <app-icon name="x" style="width: 14px; height: 14px;" />
                        </button>
                        
                        <img v-if="isImage(trainingObj.certificate_name || trainingObj.certificate_preview)" 
                             :src="getFileUrl(trainingObj.certificate_preview)" 
                             alt="Certificate Preview">
                        
                        <div v-else class="file-icon-large">
                          <app-icon :name="getFileIcon(trainingObj.certificate_name)" style="width: 48px; height: 48px;" />
                        </div>
                      </div>

                      <div class="file-thumbnail-box" v-else-if="trainingObj.certificate_path">
                        <button v-if="!isReadOnly" 
                                type="button" 
                                class="clear-file-btn" 
                                @click.stop="clearCertificateSelection">
                          <app-icon name="x" style="width: 14px; height: 14px;" />
                        </button>

                        <img v-if="isImage(trainingObj.certificate_name || trainingObj.certificate_path)" 
                             :src="getFileUrl(trainingObj.certificate_path)" 
                             alt="Certificate Preview">
                        
                        <div v-else class="file-icon-large">
                          <app-icon :name="getFileIcon(trainingObj.certificate_name || trainingObj.certificate_path)" style="width: 48px; height: 48px;" />
                        </div>
                      </div>

                      <div class="file-name-text" :title="trainingObj.certificate_name">
                        {{ trainingObj.certificate_name || 'Certificate' }}
                      </div>

                      <div class="upload-status-badge">
                         <template v-if="!trainingObj.pending_certificate && trainingObj.certificate_path">
                            <app-icon name="check-circle" style="width: 14px; height: 14px;" /> Uploaded <app-icon name="check" style="width: 14px; height: 14px;" />
                         </template>
                         <template v-else-if="trainingObj.pending_certificate">
                            <app-icon name="check-circle" style="width: 14px; height: 14px;" /> Selected <app-icon name="check" style="width: 14px; height: 14px;" />
                         </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template slot="footer">
            <button
                type="button"
                class="btn btn-secondary mr-2"
                @click="UpdateModal"
            >
              {{ $t("Update") }}
            </button>
            <button
                type="button"
                class="btn btn-primary mr-2"
                data-dismiss="modal"
                @click="closeModal"
            >
              {{ $t("Close") }}
            </button>
          </template>
        </app-modal>
      </template>
    </form>
  </div>
</template>

<script>
import AppLibrary from "@/app/Helpers/AppLibrary";
import {ModalMixin} from "../../../../../../app/Mixins/ModalMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {_statusColors} from "@Views/Screening/utility/constant";
import {
  getHighlightClass,
  getHighlightStyle,
  getLatestStatus,
  getStatusComment,
  getStatusValue,
  isRevertToApplicant
} from "@Views/Screening/utility/common";
import {File} from "@Views/Screening/utility/apiAgent";
import {APPLICANT_FILES} from "@/app/Config/ScreeningAppUrl";
import moment from "moment";

export default {
  name: "TrainingInfo",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    isReadOnly:{
      type: Boolean,
      default: false
    },
    yesOrNoList: {
      type: Array,
      required: true
    },
    training_info: {
      type: Array,
      required: true
    },
    dateFormatter: {
      type: Function,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    candidateId: {
      type: Number,
    },
    emailAddress: {
      type: String
    },
    onSaveBtn: Function,
    screeningSchedule: {
      type: [Object, Array],
      default: null,
    },
  },
  mounted() {
    this.UpdateIsTrainingRequired();
    this.mapCertificatesForTrainings();
  },
  created(){
    this.$hub.$emit("candidateDetailActiveIndex", 4);

  },
  data() {
    return {
      trainingObj: {},
      is_training: '',
      is_modal: false,
      index: 0,
      modalId: "training_modal",
      statusColors: _statusColors,
      trainingTitleList: [
        {id: "", value: "Please Select"},
        {id: "firstAid", value: "First Aid"},
        {id: "healthAndSafety", value: "Health And Safety"},
        {id: "siteTraining", value: "Site Training"},
      ],
      awardingBodyList: [
        {id: "", value: "Please Select"},
        {id: "studentGuide", value: "Student Guide"},
        {id: "pearson", value: "Pearson"},
        {id: "qa", value: "QA"},
      ],
    };
  },
  watch: {
    training_info: {
      deep: true,
      handler() {
        this.mapCertificatesForTrainings();
      }
    }
  },
  methods: {
    getHighlightStyle,
    getStatusComment,
    getLatestStatus,
    getStatusValue,
    isRevertToApplicant,
    getHighlightClass,
    async RemoveBtnHandler(index) {
      // Show native browser confirmation dialog
      const confirmed = window.confirm('Are you sure you want to delete this training certificate?');
      
      if (!confirmed) {
        return; // User cancelled
      }

      try {
        // Get the training item to be removed
        const trainingItem = this.training_info[index];
        
        // Delete associated certificate from uploaded documents if it exists
        if (trainingItem && (trainingItem.id || trainingItem.certificate_path || trainingItem.certificate_name)) {
          try {
            // Find and delete the certificate file associated with this training
            const certificateFiles = await this.findCertificateFiles(trainingItem);
            if (certificateFiles && certificateFiles.length > 0) {
              for (const file of certificateFiles) {
                await File.deleteDocument(file.id);
              }
              // Emit event to refresh Upload Documents table
              this.$hub.$emit("reload-document-table");
            }
          } catch (error) {
            console.error('Error deleting certificate:', error);
          }
        }

        // Remove from the training_info array
        if (this.training_info.length > 0) {
          this.training_info.splice(index, 1);
          
          // Call save to persist the change to backend
          try {
            await this.onSaveBtn();
          } catch (e) {
            console.error(e);
          }
          
          // Show success toaster
          this.$toastr.s('Training certificate deleted successfully!');
          
          // Update the is_training field
          this.UpdateIsTrainingRequired();
        }
      } catch (error) {
        console.error('Error removing training:', error);
      }
    },
    trainingObjCertificateChange(event) {
      const file = event?.target?.files && event.target.files[0];
      if (file) {
        this.$set(this.trainingObj, 'certificate_file', file);
        this.$set(this.trainingObj, 'certificate_name', file.name);
        this.$set(this.trainingObj, 'pending_certificate', true);
        
        // Clear old path so preview knows we are switched to a new file
        this.$set(this.trainingObj, 'certificate_path', null);
        
        // Show preview if it's an image
        if (file.type.startsWith('image/')) {
          this.$set(this.trainingObj, 'certificate_preview', URL.createObjectURL(file));
        } else {
          // Fallback or icon for non-image files if needed
          this.$set(this.trainingObj, 'certificate_preview', null);
        }
      }
    },
    async clearCertificateSelection() {
      if (this.trainingObj.certificate_path) {
        if (!confirm('Are you sure you want to delete this certificate from the database?')) {
          return;
        }
        
        try {
           let itemToSearch = this.trainingObj;
           // If we are in modal (edit mode), use the original item to find the file
           // This ensures we find the file even if user changed dates in the form without saving
           if (this.is_modal && typeof this.index !== 'undefined' && this.training_info[this.index]) {
               itemToSearch = this.training_info[this.index];
           }

           const files = await this.findCertificateFiles(itemToSearch);
           if (files && files.length > 0) {
               for (const f of files) {
                   await File.deleteDocument(f.id);
               }
               this.$toastr.s('Certificate deleted successfully.');
               
               // If in edit mode, update the original array and save
               if (this.is_modal && typeof this.index !== 'undefined' && this.training_info[this.index]) {
                   this.$set(this.training_info[this.index], 'certificate_path', null);
                   this.$set(this.training_info[this.index], 'certificate_name', null);
                   
                   try {
                       await this.onSaveBtn();
                   } catch (e) {
                       console.error(e);
                   }
               }
           }
        } catch (e) {
           console.error(e);
           this.$toastr.e('Failed to delete certificate.');
           return;
        }
      }

      this.$set(this.trainingObj, 'certificate', null);
      this.$set(this.trainingObj, 'certificate_file', null);
      this.$set(this.trainingObj, 'certificate_name', null);
      this.$set(this.trainingObj, 'certificate_preview', null);
      this.$set(this.trainingObj, 'certificate_path', null);
    },

    uploadBtnHandler(_file, _type, _issueDate = null, _expiryDate = null) {
      return new Promise((resolve, reject) => {
        let data = {email: this.emailAddress, type: _type, files: _file};
        if (_issueDate) {
          data.issue_date = moment(_issueDate).format('DD/MM/YYYY');
        }
        if (_expiryDate) {
          data.expiry_date = moment(_expiryDate).format('DD/MM/YYYY');
        }
        let formData = new FormData;
        for (const [key, value] of Object.entries(data)) {
          formData.append(key, value);
        }
        File.uploadDocument(formData)
            .then((response) => {
              this.$toastr.s(response.data.message);
              // Extract the uploaded file info (assuming it's in data or response)
              const uploadedFileData = response.data?.file || response.data?.data?.[0] || response.data;
              resolve(uploadedFileData);
            })
            .catch((error) => {
                reject(error);
            })
            .finally(() => {
              this.$hub.$emit("reload-document-table");
            });
      });
    },
    async AddBtnHandler() {
      if (this.trainingObj.title && this.trainingObj.award_date) {
        // Upload certificate if present
        if (this.trainingObj.certificate_file) {
          try {
             const uploadedFile = await this.uploadBtnHandler(
              this.trainingObj.certificate_file,
              'certificate',
              this.trainingObj.award_date,
              this.trainingObj.expiry_date
            );
            // Update the object with the real server path
            const path = uploadedFile.file_path || uploadedFile.path;
            if (uploadedFile && path) {
              this.$set(this.trainingObj, 'certificate_path', path);
              this.$set(this.trainingObj, 'certificate_name', uploadedFile.file_name || uploadedFile.name || this.trainingObj.certificate_name);
              // Ensure preview is available immediately after upload
              try {
                this.$set(this.trainingObj, 'certificate_preview', this.getFileUrl(path));
              } catch (e) {
                this.$set(this.trainingObj, 'certificate_preview', path);
              }
              this.$set(this.trainingObj, 'pending_certificate', false);
            }
          } catch (e) {
            console.error(e);
            return; // Stop if upload fails
          }
        }
        
        // Push the training object locally first
        this.training_info.push({ ...this.trainingObj });
        
        // Immediately fetch files for the new item to ensure preview works without reload
        const newItemIndex = this.training_info.length - 1;
        
        try {
          // Await save so backend has consistent state before we update the local array
          if (this.onSaveBtn) await this.onSaveBtn();

          // After save, try to refresh the specific item with server data
          if (newItemIndex >= 0) {
              const currentItem = this.training_info[newItemIndex];
              // If we already have a path from upload, keep it synced
              if (this.trainingObj.certificate_path && !currentItem.certificate_path) {
                  this.$set(currentItem, 'certificate_path', this.trainingObj.certificate_path);
                  this.$set(currentItem, 'certificate_name', this.trainingObj.certificate_name);
              }
              
              // Force a fresh fetch of files to link everything correctly
              const serverFiles = await this.findCertificateFiles(currentItem);
              if (serverFiles && serverFiles.length > 0) {
                 const srv = serverFiles[0];
                 const srvPath = srv.file_path || srv.path;
                 const srvName = srv.file_name || srv.name;
                 
                 this.$set(currentItem, 'certificate_path', srvPath);
                 this.$set(currentItem, 'certificate_name', srvName);
                 this.$set(currentItem, 'certificate_preview', this.getFileUrl(srvPath));
              }
          }

        } catch (e) {
          console.error(e);
        }
        this.trainingObj = {};
        this.UpdateIsTrainingRequired();
      } else {
        this.$toastr.e('Please fill all the fields.');
      }
    },
    async UpdateBtnHandler(index) {
      this.trainingObj = { ...this.training_info[index] };
      this.$set(this.trainingObj, 'pending_certificate', false);
      
      // If no certificate_path, try to find it
      if (!this.trainingObj.certificate_path) {
        const certificateFiles = await this.findCertificateFiles(this.trainingObj);
        if (certificateFiles && certificateFiles.length > 0) {
          // Take the latest one
          const latestFile = certificateFiles[0];
          const foundPath = latestFile.file_path || latestFile.path;
          const foundName = latestFile.file_name || latestFile.name;

          this.$set(this.trainingObj, 'certificate_path', foundPath);
          this.$set(this.trainingObj, 'certificate_name', foundName);
          
          // Update the original array so we have the path for deletion logic later
          if (this.training_info[index]) {
             this.$set(this.training_info[index], 'certificate_path', foundPath);
             this.$set(this.training_info[index], 'certificate_name', foundName);
          }
        }
      }

      // Ensure existing certificate path is mapped to preview if no new file is selected
      if (this.trainingObj.certificate_path && !this.trainingObj.certificate_preview) {
        this.trainingObj.certificate_preview = this.trainingObj.certificate_path;
      }
      this.index = index;
      this.is_modal = true;
    },
    onTrainingStatusDeleted(trainingItem, payload){
      try{
        if (!trainingItem || !Array.isArray(trainingItem.screening_status)) return;
        const idx = trainingItem.screening_status.findIndex(s => s.id === payload.id);
        if (idx !== -1){
          trainingItem.screening_status.splice(idx,1);
        }
      }catch(e){
        console.error(e);
      }
    },
    handleStatusUpdate(trainingItem, payload) {
      try {
        if (!trainingItem) return;
        if (!trainingItem.screening_status) {
          this.$set(trainingItem, "screening_status", []);
        }
        
        // Check if this is an update to existing status or a new one
        const existingIndex = trainingItem.screening_status.findIndex(s => s.id === payload.id);
        
        if (existingIndex !== -1) {
          // Update existing status
          this.$set(trainingItem.screening_status, existingIndex, {
            ...trainingItem.screening_status[existingIndex],
            action_comment: payload.action_comment,
            created_at: payload.created_at,
            include_in_report: payload.include_in_report ?? trainingItem.screening_status[existingIndex].include_in_report,
            applicant_files: payload.applicant_files || []
          });
        } else {
          // Add new status
          trainingItem.screening_status.push({
            ...payload,
            include_in_report: !!payload.include_in_report
          });
        }

        if (payload.screening_endorsement) {
          this.$set(trainingItem, "screening_endorsement", payload.screening_endorsement);
        }
      } catch (e) {
        console.error(e);
      }
    },
    async UpdateModal() {
      if (!this.trainingObj.title || !this.trainingObj.award_date) {
        this.$toastr.e('Training Title and Award Date are required.');
        return;
      }

      // Upload certificate if a new one is selected
      if (this.trainingObj.certificate_file) {
        try {
          // Delete old certificate first if it exists
          if (this.trainingObj.certificate_path || this.training_info[this.index].certificate_path) {
             const oldItem = this.training_info[this.index];
             const certificateFiles = await this.findCertificateFiles(oldItem);
             if (certificateFiles && certificateFiles.length > 0) {
               for (const file of certificateFiles) {
                 await File.deleteDocument(file.id);
               }
             }
          }

          const uploadedFile = await this.uploadBtnHandler(
              this.trainingObj.certificate_file,
              'certificate',
              this.trainingObj.award_date,
              this.trainingObj.expiry_date
          );

          // Update paths with the new uploaded file data
          const path = uploadedFile.file_path || uploadedFile.path;
          if (uploadedFile && path) {
            this.$set(this.trainingObj, 'certificate_path', path);
            this.$set(this.trainingObj, 'certificate_name', uploadedFile.file_name || uploadedFile.name || this.trainingObj.certificate_name);
            this.$set(this.trainingObj, 'certificate_file', null); // Clear the file handle
            this.$set(this.trainingObj, 'certificate_preview', null); // Clear the blob preview
          }
        } catch (e) {
          console.error(e);
          return; // Stop if upload fails
        }
      }

      // Use $set and a clone to ensure reactivity and prevent data loss
      this.$set(this.training_info, this.index, { ...this.trainingObj });

      // Hide modal properly to avoid backdrop blur issue
      $(`#${this.modalId}`).modal('hide');
      
      // Save the updated data to backend
      try {
        await this.onSaveBtn();
        this.$toastr.s('Training information updated successfully!');
      } catch (e) {
        console.error(e);
      }
      
      this.trainingObj = {}
    },
    closeModal() {
      this.is_modal = false;
      this.trainingObj = {}
    },
    async findCertificateFiles(trainingItem) {
      try {
        const response = await axios.get(`${APPLICANT_FILES}?email=${this.emailAddress}`);
        const files = response.data.data || response.data || [];

        if (!files.length) {
          return [];
        }

        const certificateFiles = files.filter(file => (file.type || '').toString().toLowerCase() === 'certificate');

        // Only use certificate files
        const sourceFiles = certificateFiles;

        if (!trainingItem) {
          return sourceFiles;
        }


        if (trainingItem.certificate_path) {
          const normalize = (p) => (p || '').toString().replace(/^\/+/, '');
          const target = normalize(trainingItem.certificate_path);
          const byPath = sourceFiles.filter(file => {
            const filePathRaw = file.file_path || file.path || '';
            const filePath = normalize(filePathRaw);
            if (!filePath || !target) return false;
            // exact match or suffix/prefix match to tolerate leading slashes and folder prefixes
            return filePath === target || filePath.endsWith(target) || target.endsWith(filePath) || filePath.includes(target) || target.includes(filePath);
          });
          if (byPath.length) {
            return byPath;
          }
        }

        // Try by Name (case-insensitive, trimmed)
        if (trainingItem.certificate_name) {
           const targetName = trainingItem.certificate_name.toString().trim().toLowerCase();
           const byName = sourceFiles.filter(file => {
             const fileName = (file.file_name || file.name || '').toString().trim().toLowerCase();
             return fileName && fileName === targetName;
           });
           if (byName.length) return byName;
        }

        const byDate = sourceFiles.filter(file => {
          if (file.issue_date && trainingItem.award_date && file.issue_date === trainingItem.award_date) {
            return true;
          }
          if (file.expiry_date && trainingItem.expiry_date && file.expiry_date === trainingItem.expiry_date) {
            return true;
          }
          return false;
        });

        if (byDate.length) {
          return byDate;
        }

        return [];
      } catch (error) {
        console.error('Error finding certificate files:', error);
        return [];
      }
    },
    async mapCertificatesForTrainings() {
      try {
        if (!Array.isArray(this.training_info) || this.training_info.length === 0) return;
        const res = await axios.get(`${APPLICANT_FILES}?email=${this.emailAddress}`);
        const allFiles = res.data.data || res.data || [];
        const certificates = allFiles.filter(f => (f.type || '').toString().toLowerCase() === 'certificate');
        const usedIds = new Set();

        const normalize = (p) => (p || '').toString().replace(/^\/+/, '');
        const fileMatchesItem = (file, item) => {
          const fp = normalize(file.file_path || file.path || '');
          const ip = normalize(item.certificate_path || '');
          const fname = (file.file_name || file.name || '').toString().trim().toLowerCase();
          const iname = (item.certificate_name || '').toString().trim().toLowerCase();
          const issueMatch = file.issue_date && item.award_date && file.issue_date === item.award_date;
          const expiryMatch = file.expiry_date && item.expiry_date && file.expiry_date === item.expiry_date;
          const pathMatch = fp && ip && (fp === ip || fp.endsWith(ip) || ip.endsWith(fp) || fp.includes(ip) || ip.includes(fp));
          const nameMatch = fname && iname && fname === iname;
          return pathMatch || nameMatch || issueMatch || expiryMatch;
        };

        for (let i = 0; i < this.training_info.length; i++) {
          const item = this.training_info[i];
          if (!item) continue;
          if (item.certificate_path) {
            // If already linked, mark it as used
            const linked = certificates.find(f => fileMatchesItem(f, item));
            if (linked) usedIds.add(linked.id);
            continue;
          }
          const match = certificates.find(f => !usedIds.has(f.id) && fileMatchesItem(f, item));
          if (match) {
            const path = match.file_path || match.path;
            const name = match.file_name || match.name;
            this.$set(this.training_info[i], 'certificate_path', path);
            this.$set(this.training_info[i], 'certificate_name', name);
            usedIds.add(match.id);
          }
        }

        // Second pass: distribute remaining certificates to trainings without any link (unique assignment)
        for (let i = 0; i < this.training_info.length; i++) {
          const item = this.training_info[i];
          if (!item || item.certificate_path) continue;
          const next = certificates.find(f => !usedIds.has(f.id));
          if (next) {
            const path = next.file_path || next.path;
            const name = next.file_name || next.name;
            this.$set(this.training_info[i], 'certificate_path', path);
            this.$set(this.training_info[i], 'certificate_name', name);
            usedIds.add(next.id);
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    UpdateIsTrainingRequired() {
      if (this.training_info.length > 0) {
        this.is_training = 'yes';
        return;
      }
      this.is_training = 'no';
    },
    getFileIcon(fileName) {
      if (!fileName) return 'file';
      const extension = fileName.split('.').pop().toLowerCase();
      if (extension === 'pdf') return 'file-text';
      return 'file';
    },
    isImage(fileName) {
      if (!fileName) return false;
      const extension = fileName.split('.').pop().toLowerCase();
      return ['jpg', 'jpeg', 'png', 'gif', 'svg'].includes(extension);
    },
    viewCertificate(path) {
      if (path) {
        const url = this.getFileUrl(path);
        window.open(url, '_blank');
      }
    },
    getFileUrl(path) {
      if (!path) return '';
      if (path.toString().includes('blob:') || path.toString().includes('http')) {
        return path;
      }
      return this.getAppUrl(path) + '?t=' + new Date().getTime();
    }
  },
  computed: {
    hasScreeningSchedule() {
      const s = this.screeningSchedule || this.training_info?.screeningSchedule;
      if (!s) return false;
      if (Array.isArray(s)) return s.length > 0;
      if (typeof s === 'object') return Object.keys(s).length > 0;
      return !!s;
    },
    today(){
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months start at 0
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }
  }
}
</script>

<style scoped>
.document-preview-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 10px;
  justify-content: flex-start;
  padding-left: 15px;
  padding-right: 15px;
}

.document-preview-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: auto;
  animation: fadeIn 0.4s ease;
}

.file-thumbnail-box {
  width: 140px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.file-thumbnail-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.file-thumbnail-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 5px;
}

.file-icon-large {
  color: #6c757d;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-name-text {
  font-weight: 600;
  margin-top: 5px;
  font-size: 14px;
  color: #3498db;
  max-width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s;
}

.document-preview-card:hover .file-name-text {
  color: #2980b9;
  text-decoration: underline;
}

.upload-status-badge {
  color: #27ae60;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  font-weight: 600;
}

.clear-file-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  color: #e74c3c;
  z-index: 2;
  transition: all 0.2s;
}

.clear-file-btn:hover {
  background: #e74c3c;
  color: #fff;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.card-item {
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 1.25rem;
  background-color: #fff;
  transition: all 0.3s ease;
}

.card-item:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  border-color: #cbd5e0;
}

.text-primary {
  color: #3498db !important;
}

.text-muted {
  color: #7f8c8d !important;
}

.fw-bold {
  font-weight: 700 !important;
}
</style>
